import { h, render, Component, createRef } from 'preact';
import { classNames, isMobileOrSmallTablet} from '../utils/utils';
import { createPopper } from '@popperjs/core';


class TxrDropdownHover extends Component {
    state = {
        isOpened: false
    }
    shouldComponentUpdate() {
        return !this.suppressUpdate;
    }
    overlay = undefined;
    suppressUpdate = false;
    refContainer = createRef();
    componentDidMount() {
       /* createPopper(popcorn, this.refItems.current, {
            placement: 'bottom',
          });*/
    }
    txrSelect = (option) => {
        this.setClose();
        if(!option.id) {
            this.props.model.value = undefined;
        } else {
            this.props.model.value = option;
        }
        
        if(this.props.model.change) {
            this.props.model.change(this.props.model);
        }
        if(this.props.select) {
            this.props.select();
        }
    }
    setOpen = () => {
        this.setState({isOpened : true});
        if(isMobileOrSmallTablet()) {
            this.suppressUpdate = true;
            this.overlay = document.createElement('div');
             this.overlay.classList.add('txr-mobile-menu-btt__overlay');
             document.body.appendChild(this.overlay);
             document.body.appendChild(this.refContainer.current);
             
             this.refContainer.current.classList.add('txr-mobile-menu-btt');
             setTimeout(() => {
                this.refContainer.current.classList.add('txr-mobile-menu-btt__opened');
             }, 10);
        }
     }

    setClose = () => {
        if(isMobileOrSmallTablet() && this.overlay) {
            document.body.removeChild(this.overlay);
            this.overlay = undefined;
            this.base.appendChild(this.refContainer.current);
            this.refContainer.current.classList.remove('txr-mobile-menu-btt');
            this.refContainer.current.classList.remove('txr-mobile-menu-btt__opened');
            //this.forceUpdate();
        }
        this.suppressUpdate = false;
        this.setState({isOpened : false});
     }
     mouseEnterOpen = () => {
        if(isMobileOrSmallTablet()) {
            return;
        }
        this.setOpen();
    }
     mouseLeaveClose = () => {
         if(isMobileOrSmallTablet()) {
             return;
         }
         this.setClose();
     }

    render() {
        return (
            <div>
                <div onMouseLeave={(e) => this.mouseLeaveClose()} class={'txr-dropdown-hover' + (this.props.model.value ? ' has-value' : '') + (this.state.isOpened ? ' txr-dropdown__opened' : '')} ref={this.refContainer}>
                    <div class="txr-dropdown__container txr-mobile-menu-btt__area">
                        <div class="dropdown-header">{this.props.header}</div>
                        <div class="txr-mobile-menu-btt__header">{this.props.mobileHeader}</div>
                        <div class="dropdown">
                            <button class="txr-dropdown__button" type="button" onClick={(e) => this.setOpen()} onMouseEnter={(e) => this.mouseEnterOpen()}>
                                <span class="txr-dropdown__title">{this.props.model.value ? this.props.model.value.title: this.props.label}</span>
                                <i class="txr-dropdown__icon fal fa-angle-down"></i>
                            </button>
                            <div class="txr-dropdown__items txr-mobile-menu-btt__items" >
                                <div class="txr-dropdown__rule"></div>
                                {
                                    this.props.options.map(option => 
                                    <a class={'txr-dropdown__item txr-mobile-menu-btt__item' + (this.props.model.value && this.props.model.value.id === option.id ? ' txr-dropdown__item-selected' : '') + (!option.id ? ' txr-dropdown__item-default' : '')} 
                                    onClick={(e) => this.txrSelect(option)}>{option.title}</a>
                                    )
                                }
                                <div class="txr-mobile-menu-btt__close txr-cancel-text__link"  onClick={(e) => this.setClose()}>Cancel</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TxrDropdownHover;